export default class RentalObjectGroup{
    groupCode : string = "";
    isRentalObjectGroup: boolean = true;
}